import { render, staticRenderFns } from "./SendQuickRecommendation.vue?vue&type=template&id=11d1716c&scoped=true&"
import script from "./SendQuickRecommendation.vue?vue&type=script&lang=js&"
export * from "./SendQuickRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./SendQuickRecommendation.vue?vue&type=style&index=0&id=11d1716c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d1716c",
  null
  
)

export default component.exports